export const round = (n, places = 1) => Math.round(10 ** places * n) / 10 ** places;
export const trunc = (n, places = 1) => Math.trunc(10 ** places * n) / 10 ** places;
//# sourceMappingURL=numbers.js.map